import { Component, Input, OnInit } from '@angular/core';
import { Filterable } from '@common/utilities/Filterable';
import { DataService, DateRange, GoodReport } from '@core/services/data.service';
import { Multilingual } from '@core/utilities/multilingual';
import { Report } from '@routes/reports/common/report';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { TagsService } from '@core/services/tags.service';
import { PartnersService } from '@core/services/partners.service';
import { SynchronizationService } from '@core/services/synchronization.service';

@Component({
  templateUrl: './returns-viewer.component.html',
  styleUrls: ['./returns-viewer.component.scss']
})
export class ReturnsViewerComponent implements OnInit {

  @Input()
  public range: { name: string, range: DateRange };

  @Input()
  public reports: GoodReport[];

  @Input()
  public SKU: string;

  @Input()
  public color: string;

  public details: Filterable<GoodReport> = new Filterable<GoodReport>({ extractor: i => [i.Path[0], this.name(i.Path[0])], grouper: i => [{ name: 'Khách hàng', option: this.name(i.Path[0]) }] });

  constructor(private tags: TagsService, private partners: PartnersService, private sync: SynchronizationService) { }

  ngOnInit(): void {

    let lu: { [key: string]: GoodReport } = {};

    this.reports.forEach(i => {
      if (!lu[i.Path[0]]) {
        lu[i.Path[0]] = { ...i };
      }
      else {
        lu[i.Path[0]].Returns.LengthCount += i.Returns.LengthCount;
        lu[i.Path[0]].Returns.LengthQuantity += i.Returns.LengthQuantity;
        lu[i.Path[0]].Returns.LengthQuoteQuantity += i.Returns.LengthQuoteQuantity;
        lu[i.Path[0]].Returns.WeightCount += i.Returns.WeightCount;
        lu[i.Path[0]].Returns.WeightQuantity += i.Returns.WeightQuantity;
        lu[i.Path[0]].Returns.WeightQuoteQuantity += i.Returns.WeightQuoteQuantity;
        lu[i.Path[0]].Returns.QuoteValue += i.Returns.QuoteValue;
        lu[i.Path[0]].Returns.QuoteWorth += i.Returns.QuoteWorth;
        lu[i.Path[0]].Returns.BaseWorth += i.Returns.BaseWorth;

      }
    })

    let source: GoodReport[] = [];

    for (let o in lu) source.push(lu[o]);   

    this.sync.when(TagsService, PartnersService).commit(() => {
      this.details.source = source.filter(i => i.Returns.LengthCount + i.Returns.WeightCount > 0);
    });    
  }

  public name(tag: string): string {
    let t = this.tags.get(tag);
    if (!t) return '';

    let p = this.partners.get(t.PartnerID);
    return p ? p.Name : '';
  }

  public extractor(field: string): SortableExtractor<GoodReport> {
    return {
      extract: i => {
        switch (field) {
          case 'Tag': return i.Path[0];
          case 'ReducedQuantity': return i.Returns.LengthQuantity + i.Returns.WeightQuantity - i.Returns.LengthQuoteQuantity - i.Returns.WeightQuoteQuantity;
          case 'QuoteQuantity': return i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity;
          case 'BasePrice': return i.Returns.BaseWorth / (i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity);
          case 'QuotePrice': return i.Returns.QuoteValue / (i.Returns.LengthQuoteQuantity + i.Returns.WeightQuoteQuantity);
          case 'Base': return i.Returns.BaseWorth;
          case 'Quote': return i.Returns.QuoteWorth;
          case 'Value': return i.Returns.QuoteValue;
          default: return i.Returns[field];
        }
      }
    }
  }

  public sum(field: string): number {
    return this.details.matches.sum(i => {
      switch (field) {
        case 'ReducedLength': return i.Returns.LengthQuantity - i.Returns.LengthQuoteQuantity;
        case 'ReducedWeight': return i.Returns.WeightQuantity - i.Returns.WeightQuoteQuantity;
        case 'Base': return i.Returns.BaseWorth;
        case 'Quote': return i.Returns.QuoteWorth;
        case 'Value': return i.Returns.QuoteValue;
        default: return i.Returns[field];
      }
    });
  }
}
